/**
 * Help tags specific to the public portal
 */
export enum PublicHelpTag {
    Checkout = 'checkout',
    Cart = 'cart',
    ManageProfile = 'manage-profile',
    Authentication = 'authentication',
    Search = 'search',
    PaymentMethods = 'payment-methods',
    PaymentHistory = 'payment-history',
    LinkedAccounts = 'linked-accounts'
}
